import React, { Component } from 'react'
import { Table, DatePicker, Button, Select, Radio, message } from 'antd'
import moment from 'moment'
import { OK } from '../../CheckOutAdvManage/constants'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'

const { RangePicker } = DatePicker

const TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '回合计费', value: 0 },
  { label: '套餐', value: 5 },
  { label: '团购', value: 7 },
  { label: '卡券', value: 8 },
  { label: '预订', value: 9 },
  { label: '定时', value: 10 },
]

class SummaryTab extends Component {
  state = {
    start_time: '',
    end_time: '',
    type: '',
    groupBy: 'table',
    statisticType: 2,
    loading: false,
    exportLoading: false,
  }

  onDateChange = (_, dateString) => {
    this.setState({ start_time: dateString[0], end_time: dateString[1] })
  }

  onTypeEvent = (type) => {
    this.setState({ statisticType: type })
  }

  onSubmit = () => {
    const { start_time, end_time, type, groupBy, statisticType } = this.state
    if (!start_time || !end_time) {
      message.info('请选择时间范围')
      return
    }
    this.setState({ loading: true })
    this.props.onFetchSummary({
      startDate: start_time, endDate: end_time, type, groupBy, statisticType,
    }).then(() => this.setState({ loading: false }))
  }

  onExport = () => {
    const { start_time, end_time, type, groupBy, statisticType } = this.state
    if (!start_time || !end_time) {
      message.info('请选择时间范围')
      return
    }
    this.setState({ exportLoading: true })
    this.props.onExport({
      startDate: start_time, endDate: end_time, type, groupBy, statisticType,
    }).then(() => this.setState({ exportLoading: false }))
      .catch(() => { this.setState({ exportLoading: false }); message.error('导出失败') })
  }

  disabledDate = (current) => current && current > moment().endOf('day')

  getColumns = () => {
    const { groupBy } = this.state
    if (groupBy === 'date') {
      return [
        { title: '日期', dataIndex: 'date', key: 'date' },
        { title: '总时长(h)', dataIndex: 'quantity', key: 'quantity' },
        { title: '套餐时长(h)', dataIndex: 'prepaidDuration', key: 'prepaidDuration' },
        { title: '团购时长(h)', dataIndex: 'grouponDuration', key: 'grouponDuration' },
        { title: '卡券时长(h)', dataIndex: 'couponDuration', key: 'couponDuration' },
        { title: '预订时长(h)', dataIndex: 'reservationDuration', key: 'reservationDuration' },
        { title: '定时时长(h)', dataIndex: 'timingDuration', key: 'timingDuration' },
        { title: '回合计费时长(h)', dataIndex: 'roundDuration', key: 'roundDuration' },
        { title: '总金额(元)', dataIndex: 'totalAmount', key: 'totalAmount' },
      ]
    }
    return [
      { title: '桌台编号', dataIndex: 'tablename', key: 'tablename' },
      { title: '日期区间', dataIndex: 'date', key: 'date' },
      { title: '总时长(h)', dataIndex: 'quantity', key: 'quantity' },
      { title: '套餐时长(h)', dataIndex: 'prepaidDuration', key: 'prepaidDuration' },
      { title: '团购时长(h)', dataIndex: 'grouponDuration', key: 'grouponDuration' },
      { title: '卡券时长(h)', dataIndex: 'couponDuration', key: 'couponDuration' },
      { title: '预订时长(h)', dataIndex: 'reservationDuration', key: 'reservationDuration' },
      { title: '定时时长(h)', dataIndex: 'timingDuration', key: 'timingDuration' },
      { title: '回合计费时长(h)', dataIndex: 'roundDuration', key: 'roundDuration' },
    ]
  }

  render() {
    const { list } = this.props
    const data = list && list.status === OK ? list.data : []
    return (
      <div>
        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
          <RangePicker disabledDate={this.disabledDate} format="YYYY-MM-DD" placeholder={['开始日期', '结束日期']} onChange={this.onDateChange} />
          <NineAndZeroRadio typeEvent={this.onTypeEvent} />
          <Select placeholder="消费类型" style={{ width: 120 }} defaultValue="" onChange={(val) => this.setState({ type: val })}>
            {TYPE_OPTIONS.map((opt) => <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>)}
          </Select>
          <Radio.Group value={this.state.groupBy} onChange={(e) => this.setState({ groupBy: e.target.value })}>
            <Radio.Button value="table">按桌台</Radio.Button>
            <Radio.Button value="date">按日期</Radio.Button>
          </Radio.Group>
          <Button type="primary" onClick={this.onSubmit} loading={this.state.loading}>查询</Button>
          <Button loading={this.state.exportLoading} onClick={this.onExport}>导出</Button>
        </div>
        <Table rowKey={(_, i) => i} bordered loading={this.state.loading} columns={this.getColumns()} dataSource={Array.isArray(data) ? data : []} pagination={{ pageSize: 20 }} scroll={{ x: 'max-content' }} />
      </div>
    )
  }
}

export default SummaryTab



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/component/SummaryTab.js